// HCRender.jsx
// Fragment loading system for HelpCenter - supports project-level overrides.
// Project can override any fragment by placing a file with the same name in:
//   components/HelpCenter/fragments/<FragmentName>.jsx

const defaultFragments = import.meta.glob(
  "aldoo-ra/HelpCenter/fragments/*.jsx",
  { eager: true }
)
const projectFragments = import.meta.glob(
  "@components/HelpCenter/fragments/*.jsx",
  { eager: true }
)

const getComponentName = (path) => {
  const parts = path.split("/fragments/")
  return parts[1].replace(".jsx", "")
}

// A single broken fragment (a bad import making its module namespace
// undefined, or a file with no default export) must never crash the whole
// SSR. Skip those fragments and log them so they can be fixed.
const collectFragments = (entries, label) =>
  Object.entries(entries).reduce((acc, [path, module]) => {
    const component = module && module.default
    if (!component) {
      console.warn(`[HCRender] skipping ${label} fragment with no default export:`, path)
      return acc
    }
    acc[getComponentName(path)] = component
    return acc
  }, {})

const DEFAULT_FRAGMENTS = collectFragments(defaultFragments, "default")
const PROJECT_FRAGMENTS = collectFragments(projectFragments, "project")

export default class HCRender {
  static getFragment(name) {
    return PROJECT_FRAGMENTS[name] || DEFAULT_FRAGMENTS[name] || null
  }
}
